export function extractS3Key(urlOrKey: string): string {
  try {
    const url = new URL(urlOrKey);
    return decodeURIComponent(url.pathname.substring(1));
  } catch {
    return urlOrKey;
  }
}

export function cleanRupees(val: string | undefined | null, defaultVal = '0'): string {
  if (!val) return defaultVal;
  let cleaned = val.replace(/[^0-9.]/g, '').trim();
  if (!cleaned || cleaned === '.') return defaultVal;
  if (cleaned.endsWith('.')) cleaned = cleaned.slice(0, -1);
  if (!cleaned) return defaultVal;
  const parts = cleaned.split('.');
  const intPart = parts[0] || '0';
  const decPart = parts[1] ? parts[1].slice(0, 2) : undefined;
  return decPart !== undefined ? `${intPart}.${decPart}` : intPart;
}

export function cleanPercentage(val: string | undefined | null, defaultVal = '18.00'): string {
  if (!val) return defaultVal;
  let cleaned = val.replace(/[^0-9.]/g, '').trim();
  if (!cleaned || cleaned === '.') return defaultVal;
  if (cleaned.endsWith('.')) cleaned = cleaned.slice(0, -1);
  if (!cleaned) return defaultVal;
  const num = Number(cleaned);
  if (isNaN(num) || num < 0) return '0';
  if (num > 100) return '100';
  const parts = cleaned.split('.');
  const intPart = parts[0] || '0';
  const decPart = parts[1] ? parts[1].slice(0, 2) : undefined;
  return decPart !== undefined ? `${intPart}.${decPart}` : intPart;
}

export function cleanHsn(val: string | undefined | null, defaultVal = '998213'): string {
  const trimmed = (val ?? '').trim();
  return trimmed.length >= 2 && trimmed.length <= 20 ? trimmed : defaultVal;
}
